/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

export interface ClientTagSignature {
  // The arguments accepted by the component
  Args: {
    client: string;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

const VARIANTS = ['green', 'yellow', 'blue'];

export default class ClientTagComponent extends Component<ClientTagSignature> {
  get variant() {
    const asciiSum = this.args.client
      .split('')
      .reduce((sum, char) => sum + char.charCodeAt(0), 0);

    return VARIANTS[asciiSum % VARIANTS.length];
  }
}
